import { cn } from '@/utils/cn';

interface LogoProps {
  className?: string;
  width?: number;
  height?: number;
}

export function Logo({ className, width = 120, height = 40 }: LogoProps) {
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <img
        src="https://calendrier-production.innov-paie.fr/logo/colored_logo.png"
        alt="Innov' Paie"
        width={width}
        height={height}
        className="h-auto object-contain"
        style={{ width: `${width}px`, height: `${height}px` }}
      />
    </div>
  );
}
